import { render } from "./PopUpCreateTeams.vue?vue&type=template&id=19ba0bac"
import script from "./PopUpCreateTeams.vue?vue&type=script&lang=js"
export * from "./PopUpCreateTeams.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__